import { LinkedSectionsModel } from '../../sections/models/linked_sections_model';
import { ISectionsDatasource } from '../../sections/datasources/sections_datasource';
import { ILocationsDatasource } from '../../sections/datasources/locations_datasource';
import { ICampusesDatasource } from '../../sections/datasources/campuses_datasource';
import { ISectionAvailabilityDatasource } from '../../sections/datasources/section_availability_datasource';
import { ILocation, ISection } from '../../../interfaces/scheduler_interfaces';
import { ISectionTimesDatasource } from '../../sections/datasources/section_times_datasource';
import { IDefineCommand, ICommand, IQuery, IQueryMediator } from 'core-ts-types';
import { ScheduledSectionStatus } from '../../course_scheduler/types/scheduled_section_status_enum';
import * as _4 from 'lodash4';
import { SectionSwapModel, ISectionSwapToFrom } from '../../../swap/models/course_section_swap_model';
import { MultiSectionServant } from '../../course_scheduler/servants/multi_section_servant';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { ISectionLabelsDatasource } from '../../sections/datasources/section_labels_datasource';
import { GetSectionAvailabilityCommand } from './get_unscheduled_sections_availability_command';
angular
  .module('capability-ng-scheduler')
  .factory(
    'getUnscheduledSectionsandAvailabilityCommand',
    (
      $http: ng.IHttpService,
      $q: ng.IQService,
      defineCommandORM: IDefineCommand,
      QueryMediator: IQueryMediator,
      ngSectionAvailabilityDatasource: ISectionAvailabilityDatasource,
      ngCampusesDatasource: ICampusesDatasource,
      ngMultiSectionServant: MultiSectionServant,
      ngLocationsDatasource: ILocationsDatasource,
      ngSectionsDatasource: ISectionsDatasource,
      ngSectionLabelsDatasource: ISectionLabelsDatasource,
      ngSectionTimesDatasource: ISectionTimesDatasource,
      ngLinkedSectionsModel: LinkedSectionsModel,
      ngCourseSectionSwapModel: SectionSwapModel,
      getSectionAvailabilityCommand: GetSectionAvailabilityCommand,
      ngComponentCommunicatorService: CommunicatorService
    ): ICommand => {
      return defineCommandORM(
        'getUnscheduledSectionsandAvailabilityCommand',
        (
          deferred: ng.IDeferred<IQuery[]>,
          termId: number,
          courseId: number,
          sectionTypeId: number,
          ignoreConflicts: number[],
          selectedSwapIds: number[]
        ): ng.IPromise<void> => {
          if (_4.isEmpty(sectionTypeId)) {
            sectionTypeId = 0;
          }

          let ignoreConflictIds = '';
          let sectionSwapIdString = '';

          if (ignoreConflicts) {
            ignoreConflictIds =
              '?ignore_conflicting_id=' +
              _4.reduce(ignoreConflicts, (sum: any, item: number) => `${sum}&ignore_conflicting_id=${item}`);
          }

          if (!_4.isEmpty(selectedSwapIds)) {
            sectionSwapIdString = ngMultiSectionServant.getSelectedSwapIds(selectedSwapIds);
          }

          return getSectionAvailabilityCommand(
            termId,
            courseId,
            sectionTypeId,
            `${ignoreConflictIds}${sectionSwapIdString}`
          ).then(() =>
            $q
              .all({
                sections: $http({
                  method: 'GET',
                  url: `cat/sections/term/${termId}/course/${courseId}/section_type/${sectionTypeId}/`
                })
              })
              .then((responses: Record<string, ng.IHttpPromiseCallbackArg<any>>) => {
                ngLocationsDatasource.write(responses.sections.data.location);
                ngSectionLabelsDatasource.write(responses.sections.data.section_labels);
                const prevRegisteredSections = _4.filter(
                  ngSectionsDatasource.read(),
                  (section) => section.status !== ScheduledSectionStatus.UNSCHEDULED
                );
                ngCampusesDatasource.write(responses.sections.data.campus);
                ngSectionTimesDatasource.write(responses.sections.data.section_time);

                // Sections datasource must be written after SectionTimes, to
                // have proper data when creating meta props
                ngSectionsDatasource.write(responses.sections.data.section);
                ngSectionsDatasource.write(prevRegisteredSections);
                deferred.resolve();
                ngComponentCommunicatorService.publish('SECTIONS_LOADED');
              })
              .catch((error) => {
                ngComponentCommunicatorService.publish('SECTIONS_LOADED');
                deferred.reject(error);
              })
          );
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/unscheduled_sections/commands/get_unscheduled_sections_and_availability_command.ts